import { useMemo } from 'react';
import { Card, CardContent } from '@mui/material';
import { Edit, Form, Toolbar, useEditController } from 'react-admin';
import type { Organization } from '@wwf/sdk';
import { OrganizationInputs } from './OrganizationInputs';
import { organizationToInput } from '@domain/organization';

export const OrganizationEdit = () => {
    return (
        <Edit mutationMode="pessimistic" redirect="show">
            <OrganizationEditForm />
        </Edit>
    );
};

const OrganizationEditForm = () => {
    const { record } = useEditController<Organization>();
    const formRecord = useMemo(
        () => (record ? organizationToInput(record) : undefined),
        [record]
    );

    if (!formRecord) return null;

    return (
        <Form record={formRecord}>
            <Card>
                <CardContent>
                    <OrganizationInputs />
                </CardContent>
                <Toolbar />
            </Card>
        </Form>
    );
};
